import React, { Component } from "react";
import { HotTable } from "@handsontable/react";
import { utils } from "~/utils";

export default class TrackerTable extends Component {
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
    }

    render() {
        const { oet, status } = this.props;
        const data = this.getData(oet);
        const table_op = {
            width: "100%",
            height: 500,
            stretchH: "all",
            beforeChange: this.onBeforeHotChange,
            settings: {
                tableClassName: ["table", "table-bordered", "table-striped"],
                fillHandle: true,
                // disableVisualSelection: true,
                wordWrap: true,
                stretchH: "none",
                className: "htCenter htMiddle",
                colHeaders: this.getColHeaders(status),
                columns: this.getColumns(status),
                data
            }
        };
        return (
            <div>
                <HotTable ref={this.hotTableComponent} {...table_op} />
            </div>
        );
    }

    onBeforeHotChange = (changes, source) => {
        const hot = this.hotTableComponent.current.hotInstance;
        if (source === "edit") {
            const { oet, onItemsChange } = this.props;
            const [row, key, , newValue] = changes[0];
            const dataRow = hot.getSourceDataAtRow(row);
            const oldItem = oet.items.find(item => item.id === dataRow.id);
            let newItem = null;
            if (oldItem.hasOwnProperty(key)) {
                newItem = Object.assign({}, oldItem);
                newItem[key] = newValue;
            }
            onItemsChange({ oldItem, newItem });
        }
    };

    getColHeaders = () => [
        "Total Value</br>of PO INR",
        "PO QTY in</br>SAP",
        "PO QTY</br>Pending",
        "PO Value</br>Pending",
        "Total</br>Invoiced<br/>QTY",
        "Total<br/>Invoiced</br>Value",
        "To be<br/>Invoiced<br/>QTY",
        "To be<br/>Invoiced<br/>Value",
        "QTY for<br/>Invoice<br/>Pending",
        "Value of<br/>Invoice<br/>Pending",
        "Billing<br/>Document<br/>Numbers<br/>created #",
        "Billing<br/>Document</br>Date"
    ];

    getColumns = status => {
        const is_editable = !(status > 0);
        const res = [
            {
                data: "total_value_of_po",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "po_qty_in_sap",
                className: "htRight htMiddle",
                ...(is_editable ? {} : { editor: false })
            },
            {
                data: "po_qty_pending",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "po_value_pending",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "total_invoiced_qty",
                ...(is_editable ? {} : { editor: false }),
                className: "htRight htMiddle"
            },
            {
                data: "total_invoiced_value",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "to_be_invoiced_qty",
                ...(is_editable ? {} : { editor: false }),
                className: "htRight htMiddle"
            },
            {
                data: "to_be_invoiced_value",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "qty_for_invoice_pending",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "value_of_invoice_pending",
                editor: false,
                className: "htRight htMiddle"
            },
            {
                data: "billing_document_numbers_created",
                ...(is_editable ? {} : { editor: false }),
                className: "htRight htMiddle"
            },
            {
                data: "billing_document_date",
                ...(is_editable ? {} : { editor: false }),
                className: "htRight htMiddle"
            }
        ];
        return res;
    };

    getData = oet => {
        const { itemID } = this.props;
        if (oet) {
            const { items } = oet;
            if (items) {
                let filterItems = [...items];
                if (itemID) {
                    filterItems = filterItems.filter(item => parseInt(item.id, 10) === parseInt(itemID, 10));
                }
                const res = filterItems.map(item => ({
                    ...item,
                    total_value_of_po: item.total_value_of_po.toFixed(2),
                    po_value_pending: item.po_value_pending.toFixed(2),
                    total_invoiced_value: item.total_invoiced_value.toFixed(2),
                    to_be_invoiced_value: item.to_be_invoiced_value.toFixed(2),
                    value_of_invoice_pending: item.value_of_invoice_pending.toFixed(2),
                    billing_document_date: utils.renderDate(item.billing_document_date)
                }));
                return res;
            }
        }
        return [{}];
    };
}
